<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <form class="card p-2" @submit.prevent="submitForm">
              <div class="card-block">
                <h1>Nouveau mot de passe</h1>
                <p class="text-muted">Définissez votre nouveau mot de passe</p>

                <div v-if="loading" class="text-center py-2">
                  <p>Vérification en cours...</p>
                </div>

                <div v-else-if="invalidKey" class="alert alert-danger">
                  Ce lien de réinitialisation est invalide ou a expiré.
                </div>

                <template v-else>
                  <div class="mb-1">
                    <label class="text-muted small mb-0"
                      >Nouveau mot de passe</label
                    >
                    <password-input
                      v-model="newPassword"
                      :disabled="submitting || success"
                      :has-error="!!formError && !newPassword"
                    />
                  </div>
                  <div class="mb-2">
                    <label class="text-muted small mb-0"
                      >Confirmer le nouveau mot de passe</label
                    >
                    <password-input
                      v-model="newPasswordConfirmation"
                      :disabled="submitting || success"
                      :has-error="!!formError && !newPasswordConfirmation"
                    />
                  </div>

                  <div v-if="formError" class="alert alert-danger">
                    {{ formError }}
                  </div>

                  <div v-if="success" class="alert alert-success">
                    Mot de passe modifié avec succès. Vous allez être redirigé
                    vers la page de connexion...
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <button
                        type="submit"
                        class="btn btn-primary px-2"
                        style="background-color: #2f323a; border-color: #2f323a"
                        :disabled="submitting || success"
                      >
                        Valider
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </form>
            <div
              class="card card-inverse card-primary py-3 hidden-md-down"
              style="width: 44%; background-color: #2f323a; border-color: #2f323a"
            >
              <div class="card-block text-center">
                <div>
                  <img
                    src="/static/img/moov-on-mark.png"
                    alt="moov'on"
                    style="width: 96px; height: 96px; border-radius: 16px; margin-bottom: 16px"
                  />
                  <h2>moov'on</h2>
                  <p>Interface de gestion.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordInput from "@/components/form/PasswordInput";

export default {
  components: { PasswordInput },

  name: "PasswordReset",

  data() {
    return {
      loading: true,
      invalidKey: false,
      newPassword: "",
      newPasswordConfirmation: "",
      formError: null,
      success: false,
      submitting: false,
    };
  },

  async created() {
    const key = this.$route.params.key;
    try {
      await this.$api.get(`/users/validate-reset-password-code/${key}`);
      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.invalidKey = true;
    }
  },

  beforeDestroy() {
    clearTimeout(this._redirectTimer);
  },

  methods: {
    async submitForm() {
      if (this.submitting || this.success) return;
      this.formError = null;

      if (!this.newPassword) {
        this.formError = "Le nouveau mot de passe est obligatoire";
        return;
      }
      if (!this.newPasswordConfirmation) {
        this.formError = "La confirmation du mot de passe est obligatoire";
        return;
      }
      if (this.newPassword !== this.newPasswordConfirmation) {
        this.formError = "Les mots de passe ne correspondent pas";
        return;
      }

      const key = this.$route.params.key;

      this.submitting = true;
      try {
        await this.$api.post("/users/define-password", {
          newPassword: this.newPassword,
          validationCode: key,
        });

        this.success = true;

        this._redirectTimer = setTimeout(() => {
          this.$router.push({ name: "login" });
        }, 2000);
      } catch (e) {
        this.formError =
          "Impossible de modifier le mot de passe. Veuillez réessayer.";
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
